import React from 'react';
import messages from "res/messages/farsi";

import IconTitleValue from "components/textValue/IconTitleValue";

import {useHistory} from "react-router-dom";
import getColorByTicketStatus from "./TicketUtility";

import {IsM_SM} from "my-styles/media/media";

import ICCalender from "res/images/calendar.png";

import ICStatus from "res/images/done.png";
import ICEdit from "res/images/edit.png";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";

import ICLeftArrow from "res/images/left_arrow.png";
import {Divider} from "@material-ui/core";
import StandardButton from "components/buttons/StandardButton";
import ICArrowBackIosIcon from "res/images/left_arrow_dark.png";
import ICComment from "res/images/comment.png";

export default function Ticket(props) {

    const history = useHistory()
    let ticket = props.ticket
    let itemCount = IsM_SM() ? 3 : 5

    const onShowticketDetail = (e) => {
        props.onNavigate(history, '/ticketDetail', {
            ticket_id: ticket.id,
            page: props.page
        })
        e.stopPropagation()
    }

    const truncateText = (text, maxLength) => {
        // جدا کردن متن به کلمات
        const words = text.split(' ');

        // اگر تعداد کلمات کمتر یا مساوی با maxLength باشد، هیچ تغییری نده
        if (words.length <= maxLength) {
            return text;
        }

        // برش اولیه تا maxLength
        const truncatedWords = words.slice(0, maxLength);

        // اضافه کردن سه نقطه به انتها و تبدیل به متن
      return  truncatedWords.join(' ') + '...';

    };


    return (<div className="fullWidth marginSmall responseCardTicket">
        {
        <div className="marginTopBottomSmall card fullHeight" onClick={onShowticketDetail}>
            <div className="horizontalFullScreen">
                <div className="card_blue_left_curve_ticket marginTopBottomMedium">
                    <IconTitleValue
                        valueClassName={"whiteColor"}
                        titleClassName={"whiteColor"}
                        title={messages.ticketNumber}
                        value={ticket.id}/>
                </div>
                <div style={{position: "absolute", left: "0"}} className="marginTopBottomMedium">
                    <div className={ticket.status_type===0 ? "card_light_blue_right_curve_ticket" :"card_green_right_curve_ticket"}>
                        <IconTitleValue
                            valueClassName={"whiteColor"}
                            titleClassName={"whiteColor"}

                            value={ticket.status}/>
                    </div>

                </div>
            </div>
            <div className="marginRightSmall">
                <IconTitleValue
                    valueClassName={getColorByTicketStatus(ticket.status_type) + " mediumTextBold"}
                    icon={<img src={ICEdit} alt="صرفه مارکت"  className="xxSmallIcon"/>}
                    title={messages.subject}
                    value={ticket.title}/>
                <IconTitleValue
                    valueClassName={"mediumTextBold"}
                    icon={<img src={ICComment} alt="صرفه مارکت"  className="xxSmallIcon"/>}
                    title={messages.messageDescription}
                    value={truncateText(ticket.message,10)}/>
                <IconTitleValue
                    valueClassName={"mediumTextBold"}
                    icon={<img src={ICCalender} alt="صرفه مارکت"  className="xxSmallIcon"/>}
                    title={messages.RegistrationDate}
                    value={ticket.dataShamsi} />

            </div>

            {
                <div>
                    <table className="horizontalFullScreen" style={{marginBottom:'3rem'}}>
                        <tbody>
                        <tr>
                            {
                                props.ticketImages.map((value, index) => {

                                          if(value.length>0){
                                              return (
                                                  <td key={index}>
                                                      <div className="horizontalScreen">
                                                          <img src={value} alt="صرفه مارکت-پشتیبانی"  className="largeIcon"/>
                                                          <div>
                                                              <Divider orientation={"vertical"}/>
                                                          </div>
                                                      </div>
                                                  </td>
                                              )
                                          }

                                        })

                            }

                            {
                                props.ticketImages.length > 1 ? (
                                    <td>
                                        <StandardButton
                                            icon={<img src={ICArrowBackIosIcon} alt="صرفه مارکت"  className="xxxxSmallIcon"  />}
                                            onClick={onShowticketDetail}
                                        />
                                    </td>
                                ) : null
                            }

                        </tr>
                        </tbody>
                    </table>
                </div>
            }
            <div className="horizontalScreen" style={{float: "left"}}>
                {
                    <div className="marginSmall" style={{position:'absolute',left:0,bottom:'0.2rem'}}>
                        <IconTitleButtonRound
                            height={"2.7em"}
                            direction="ltr"
                            fontSize="smallTextBold"
                            title={messages.detail}
                            icon={<img className="xxSmallIcon" src={ICLeftArrow} alt="صرفه مارکت" />}
                            iconLeft='true'
                            onClick={onShowticketDetail}/>
                    </div>
                }
            </div>

        </div>
        }

    </div>)
}